<script lang="ts">
	import { getImageUrl } from '../../../utils/getImageUrl';
	import type { ButtonProps } from '../../Button';
	import { Hero } from '../../Hero';
	import type { Hero as HeroType } from '../types';

	interface Props {
		class?: string;
		hero: HeroType;
		isLive: boolean;
		enforcedDesktopImage?: string | null;
		enforcedMobileImage?: string | null;
		disableLinks?: boolean;
		desktopImageStyle?: string;
		mobileImageStyle?: string;
	}

	let {
		hero,
		isLive,
		enforcedDesktopImage,
		enforcedMobileImage,
		disableLinks = false,
		desktopImageStyle,
		mobileImageStyle,
		...props
	}: Props = $props();

	let desktopImage = $derived(
		enforcedDesktopImage || getImageUrl(hero?.desktop_image?.filename_disk, '2048px')
	);

	let mobileImage = $derived(
		enforcedMobileImage || getImageUrl(hero?.desktop_image?.filename_disk, '2048px')
	);

	let link = $derived(hero?.button_1_link);
	let label = $derived(hero?.button_1_label);

	let link2 = $derived(hero?.button_2_link);
	let label2 = $derived(hero?.button_2_label);

	let buttonProps = $derived(
		link && label
			? {
					href: link,
					label: isLive ? 'View Release' : label,
					arrow: true,
					variant: (hero?.button_1_variant || 'ghost') as ButtonProps['variant']
				}
			: undefined
	);

	let secondaryButtonProps = $derived(
		link2 && label2
			? {
					href: link2,
					label: label2,
					arrow: true,
					variant: (hero?.button_2_variant || 'ghost') as ButtonProps['variant']
				}
			: undefined
	);

	const handleClick = (e?: Event) => {
		if (disableLinks && e) {
			e.preventDefault();
		}
	};
</script>

<Hero
	dataCy="editions-home-hero"
	mobileSrc={mobileImage}
	src={desktopImage}
	title={hero.surtitle || ''}
	textShadow={!!hero.text_shadow}
	highResolution={!hero?.image_compressed}
	alt={hero.surtitle}
	subtitle={hero?.title}
	overline={hero?.subtitle}
	{buttonProps}
	{secondaryButtonProps}
	align="center"
	layerOpacity={[null, undefined].includes(hero['layer_opacity'] as null | undefined)
		? 0.1
		: (hero['layer_opacity'] as number)}
	class={props.class}
	{isLive}
	onclick={handleClick}
	{desktopImageStyle}
	{mobileImageStyle}
/>
